module.exports = __webpack_public_path__ + "img/logoDenominacionOnly.36f3a0e5.png";